import axiosClient from "./axiosClient";

const paymentApi = {
    getOnPay: (data) => axiosClient.post("/api/bookings/createPayment", data),
    checkStatus: (reference) => axiosClient.get(`api/bookings/payment/status?reference=${reference}`)
}

export default paymentApi;